import {useEffect} from "react";
import {useNavigate, useSearchParams} from "react-router-dom";
import {URLS} from "../../apiService";

export default function GoogleAuthHandler() {
    const [params] = useSearchParams();
    const navigate = useNavigate();

    useEffect(() => {
        const email = params.get("email");
        const name = params.get("name");

        if (!email) {
            navigate("/login");
            return;
        }

        fetch(`${URLS.user}/auth/google/sso-login`, {
            method: "POST",
            headers: {"Content-Type": "application/json"},
            body: JSON.stringify({email, name}),
        })
            .then(res => res.json())
            .then(data => {
                const token = data?.data?.token;
                const user = data?.data?.user;

                if (!token || !user) {
                    navigate("/login");
                    return;
                }

                // BOTH ARE REQUIRED
                localStorage.setItem("authToken", token);
                localStorage.setItem("user", JSON.stringify(user));

                navigate("/dashboard", {replace: true});
            })
            .catch(() => navigate("/login"));
    }, [navigate, params]);

    return <p>Signing you in with Google...</p>;
}
